import { render, staticRenderFns } from "./Notice.vue?vue&type=template&id=5cf204ad&scoped=true&"
import script from "./Notice.vue?vue&type=script&lang=ts&"
export * from "./Notice.vue?vue&type=script&lang=ts&"
import style0 from "./Notice.vue?vue&type=style&index=0&id=5cf204ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf204ad",
  null
  
)

export default component.exports